import { makeApiCall } from "../makeApiCall";
import { AdminService_URL, ThirdPartyService_URL } from "../Url";

export const ColdChainDashActions = {
  COLDCHAIN_DASHBOARD_SUCCESS: "COLDCHAIN_DASHBOARD_SUCCESS",
  COLDCHAIN_DASHBOARD_FAILURE: "COLDCHAIN_DASHBOARD_FAILURE",
  COLDCHAIN_MANIFEST_SUCCESS: "COLDCHAIN_MANIFEST_SUCCESS",
  COLDCHAIN_MANIFEST_FAILURE: "COLDCHAIN_MANIFEST_FAILURE",
  MARK_DELIVERED_SUCCESS: "MARK_DELIVERED_SUCCESS",
  MARK_DELIVERED_FAILURE: "MARK_DELIVERED_FAILURE",
  HAND_DELIVERED_SUCCESS: "HAND_DELIVERED_SUCCESS",
  HAND_DELIVERED_FAILURE: "HAND_DELIVERED_FAILURE",
  GET_ROLE_SUCCESS: "GET_ROLE_SUCCESS",
  GET_ROLE_FAILURE: "GET_ROLE_FAILURE",
  GET_ROLE_ID_SUCCESS: "GET_ROLE_ID_SUCCESS",
  GET_ROLE_ID_FAILURE: "GET_ROLE_ID_FAILURE",
  ASSIGN_RUNNER_SUCCESS: "ASSIGN_RUNNER_SUCCESS",
  ASSIGN_RUNNER_FAILURE: "ASSIGN_RUNNER_FAILURE",
};

////? Checker dashboard Service

export function coldchainDashboardSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: ColdChainDashActions.COLDCHAIN_DASHBOARD_SUCCESS,
      payload: props,
    });
  };
}

export function coldchainDashboardFailureAction(error) {
  return {
    type: ColdChainDashActions.COLDCHAIN_DASHBOARD_FAILURE,
    payload: error,
  };
}

export function coldchainDashboardThunk(props, warehouseIds) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/getColdChainDashboard?fromDate=${
    props.fromDate
  }&toDate=${props.toDate}${
    props.isPickingPending === true
      ? "&isPickingPending=true"
      : props.isPendingForDispatch === true
      ? "&isPendingForDispatch=true"
      : props.isDispatched === true
      ? "&isDispatched=true"
      : props.isColdChain === true
      ? "&isColdChain=true"
      : ""
  }`;

  // const postUrl = `https://12ded7bc-d8e4-42fb-ad0d-eb1bc4da9e5f.mock.pstmn.io/getColdChainDashboard?fromDate=${
  //   props.fromDate
  // }&toDate=${props.toDate}${
  //   props.isPickingPending === true
  //     ? "&isPickingPending=true"
  //     : props.isPendingForDispatch === true
  //     ? "&isPendingForDispatch=true"
  //     : props.isDispatched === true
  //     ? "&isDispatched=true"
  //     : props.isColdChain === true
  //     ? "&isColdChain=true"
  //     : ""
  // }`;
  return makeApiCall(
    postUrl,
    coldchainDashboardSuccessAction,
    coldchainDashboardFailureAction,
    "POST",
    warehouseIds,
    reqHeader,
    props.history
  );
}

////? Checker dashboard CSV Manifest Service

export function coldchainManifestSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: ColdChainDashActions.COLDCHAIN_MANIFEST_SUCCESS,
      payload: props,
    });
  };
}

export function coldchainManifestFailureAction(error) {
  return {
    type: ColdChainDashActions.COLDCHAIN_MANIFEST_FAILURE,
    payload: error,
  };
}

export function coldchainManifestThunk(props) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/exportColdChainManifest?warehouseId=${props.warehouseId}`;

  return makeApiCall(
    postUrl,
    coldchainManifestSuccessAction,
    coldchainManifestFailureAction,
    "POST",
    null,
    reqHeader,
    props.history
  );
}

////? Checker dashboard Dispatched Service

export function handDeliveredSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: ColdChainDashActions.MARK_DELIVERED_SUCCESS,
      payload: props,
    });
  };
}

export function handDeliveredFailureAction(error) {
  return {
    type: ColdChainDashActions.MARK_DELIVERED_FAILURE,
    payload: error,
  };
}

export function handDeliveredThunk(props) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${ThirdPartyService_URL}/handDeliveredRequest?orderId=${props.orderId}&salesOrderId=${props.salesOrderId}&packageId=${props.packageId}&isNewFlow=true`;

  return makeApiCall(
    postUrl,
    handDeliveredSuccessAction,
    handDeliveredFailureAction,
    "POST",
    null,
    reqHeader,
    props.history
  );
}

////? Checker dashboard Mark as Delivered Service

export function markDeliveredSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: ColdChainDashActions.HAND_DELIVERED_SUCCESS,
      payload: props,
    });
  };
}

export function markDeliveredFailureAction(error) {
  return {
    type: ColdChainDashActions.HAND_DELIVERED_FAILURE,
    payload: error,
  };
}

export function markDeliveredThunk(props) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${ThirdPartyService_URL}/handDelivered?orderId=${props.orderId}`;

  return makeApiCall(
    postUrl,
    markDeliveredSuccessAction,
    markDeliveredFailureAction,
    "POST",
    null,
    reqHeader,
    props.history
  );
}

////? Checker dashboard Runner Service - get role

export function getRoleSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: ColdChainDashActions.GET_ROLE_SUCCESS,
      payload: props,
    });
  };
}

export function getRoleFailureAction(error) {
  return {
    type: ColdChainDashActions.GET_ROLE_FAILURE,
    payload: error,
  };
}

export function getRoleThunk(props) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/getRole`;

  return makeApiCall(
    postUrl,
    getRoleSuccessAction,
    getRoleFailureAction,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

////? Checker dashboard Runner Service - get user by ID

export function getRoleByIDSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: ColdChainDashActions.GET_ROLE_ID_SUCCESS,
      payload: props,
    });
  };
}

export function getRoleByIDFailureAction(error) {
  return {
    type: ColdChainDashActions.GET_ROLE_ID_FAILURE,
    payload: error,
  };
}

export function getRoleByIDThunk(props) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/getUsersByRoleId?roleId=${props.roleId}`;

  return makeApiCall(
    postUrl,
    getRoleByIDSuccessAction,
    getRoleByIDFailureAction,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

////? Checker dashboard Assign Runner

export function assignRunnerSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: ColdChainDashActions.ASSIGN_RUNNER_SUCCESS,
      payload: props,
    });
  };
}

export function assignRunnerFailureAction(error) {
  return {
    type: ColdChainDashActions.ASSIGN_RUNNER_FAILURE,
    payload: error,
  };
}

export function assignRunnerThunk(props) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/assignRunnerToOrder?orderId=${props.orderId}&runnerId=${props.runnerId}`;

  return makeApiCall(
    postUrl,
    assignRunnerSuccessAction,
    assignRunnerFailureAction,
    "POST",
    null,
    reqHeader,
    props.history
  );
}
